import { Box } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '../theme/tokens';
import { Skeleton } from './Skeleton';

const Container = styled(Box)<{
	progress: number;
}>`
	width: 32px;
	height: 32px;
	padding: 2px;
	border-radius: 16px;
	background: ${(props) => `conic-gradient(
		${props.theme.colors.primary} 0deg,
		${props.theme.colors.primary} ${(props.progress * 360).toFixed()}deg,
		${props.theme.colors.lightBlueLight} ${(props.progress * 360).toFixed()}deg
	)`};
`;

const Text = styled(Box)`
	width: 28px;
	height: 28px;
	color: ${tokens.text.primary};
	border-radius: 14px;
	font-family: Poppins, sans-serif;
	font-weight: bold;
	background: white;
	text-align: center;
	line-height: 28px;
	font-size: 10px;
`;

export const ProgressPie = Skeleton(
	function ProgressPie(props: { progress: number }) {
		return (
			<Container progress={props.progress}>
				<Text>{(props.progress * 100).toFixed()}%</Text>
			</Container>
		);
	},
	styled(Skeleton.Box)`
		width: 32px;
		height: 32px;
		border-radius: 16px;
		padding: 2px;

		::after {
			content: '';
			width: 28px;
			height: 28px;
			display: block;
			border-radius: 14px;
			background-color: ${(props) => props.theme.colors.white};
		}
	`,
);
